import { Injectable } from '@angular/core'
import { Store } from '../../models/store'

export interface DocumentationStateModel {
    brouillonCounter: number
}
@Injectable({ providedIn: 'root' })
export class DocumentationState {
    store = new Store<DocumentationStateModel>({ brouillonCounter: 0 })

    static getBrouillonCounter = (state: DocumentationStateModel): number => state.brouillonCounter
}
